export interface TabConfig {
  key: string;
  label: string;
  enabled: boolean;
  comingSoon?: boolean;
}

export const CLIENTE_TABS: TabConfig[] = [
  { key: 'resumo', label: 'Resumo', enabled: true },
  { key: 'produtos', label: 'Produtos', enabled: true },
  { key: 'vendas', label: 'Vendas', enabled: true },
  { key: 'saques', label: 'Saques', enabled: false, comingSoon: true },
  { key: 'chargebacks', label: 'Chargebacks', enabled: false, comingSoon: true },
  { key: 'recebiveis', label: 'Recebíveis', enabled: false, comingSoon: true },
  { key: 'kyc', label: 'KYC', enabled: false, comingSoon: true },
];

export const findTab = (key: string): TabConfig | undefined =>
  CLIENTE_TABS.find((t) => t.key === key);
